import type { ReactNode } from 'react';
import React, { createContext, use, useState } from 'react';

interface DriverContextType {
  driver: { code?: string; token?: string; enquiryId?: number } | null;
  setDriver: React.Dispatch<React.SetStateAction<{ code?: string; token?: string; enquiryId?: number } | null>>;
}

const DriverContext = createContext<DriverContextType | undefined>(undefined);

export const DriverProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [driver, setDriver] = useState<DriverContextType['driver']>(null);

  return (
    <DriverContext value={{ driver, setDriver }}>
      {children}
    </DriverContext>
  );
};

export const useDriver = () => {
  const context = use(DriverContext);
  if (!context) {
    throw new Error('useDriver must be used within a DriverProvider');
  }
  return context;
};
